import ActionTypes from '../constants';

const initialState = {
    loading: false,
    addEditLoading: false,
    indexLoading: false,
};


const loadingReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case ActionTypes.ADDEDITLOADING:
            return {
                ...state,
                addEditLoading: action.payload
            };
        case ActionTypes.INDEXLOADING:
            return {
                ...state,
                indexLoading: action.payload
            };
        default:
            return state;
    }
}
export default loadingReducer;